module.exports = {
    //urlTest: `http://localhost:4000/`,
    // urlBase: `http://localhost:1337/`,
    urlBase: `https://container-back-maquetas-v1.etm6qeo1eo20q.us-east-1.cs.amazonlightsail.com/`,
    urlTest: `https://container-back-maquetas-v1.etm6qeo1eo20q.us-east-1.cs.amazonlightsail.com/`
}